import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ApiAuthService } from '../data-access/api/api-auth.service';

/**
 * Protects the application shell in API mode. Mock mode intentionally remains
 * directly navigable so demonstrations do not require a backend session.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  if (environment.dataSource === 'mock') return true;

  const auth = inject(ApiAuthService);
  const router = inject(Router);
  if (auth.accessToken()) return true;

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url || '/dashboard' },
  });
};
